import type { AssetType, Stored } from "@overmap-ai/common"
import { Mention } from "@tiptap/extension-mention"
import { mergeAttributes, ReactNodeViewRenderer } from "@tiptap/react"

import type { MentionOptions } from "../typings"
import { AssetTypeMentionComponent } from "./Component"
import { suggestion } from "./suggestion"

export const AssetTypeMention = Mention.extend<MentionOptions<Stored<AssetType>>>({
	name: "AssetTypeMention",
	atom: true,
	addAttributes() {
		return {
			uuid: {
				default: null,
			},
		}
	},
	parseHTML() {
		return [
			{
				tag: "asset-type-mention",
			},
		]
	},
	renderHTML({ HTMLAttributes }) {
		return ["asset-type-mention", mergeAttributes(HTMLAttributes)]
	},
	addNodeView() {
		return ReactNodeViewRenderer(AssetTypeMentionComponent)
	},
}).configure({
	suggestion,
})
